import { PropsWithChildren, createContext, useEffect, useMemo, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
// import { Theme } from "@mui/material/styles/createTheme";

import Dark from "./Dark";
import Light from "./Light";
// import Context, { ThemeType } from "./Context";

const getTheme = (themeType: ThemeType) => {
    switch(themeType) {
        case ThemeType.Dark:
            return Dark;
        case ThemeType.Light:
            return Light;
        default:
            throw new Error(`Unknown theme ${themeType}`);
    }
}

export enum ThemeType {
    Dark,
    Light
}
// export default createContext({
//     setSelected: (selectedInfo: Theme): void => {},
// });

interface ContextInfo {
    theme: ThemeType,
    setTheme: (themeType: ThemeType) => void,
}

export const Context = createContext<ContextInfo>({
    theme: ThemeType.Dark,
    // eslint-disable-next-line no-unused-vars
    setTheme: (themeType: ThemeType): void => {
        // init context
    }
});

// export const Context = createContext(getTheme(ThemeType.Dark));

export default ({children}: PropsWithChildren) => {
    const [theme, setTheme] = useState<ThemeType>(ThemeType.Dark);
    const [themeLoaded, setThemeLoaded] = useState(false);

    const themeResult = useMemo(() => getTheme(theme), [theme]);

    useEffect(() => {
        const storedTheme = localStorage.getItem("theme");
        if (storedTheme !== null) {
            setTheme(ThemeType[storedTheme as keyof typeof ThemeType]);
        }
        setThemeLoaded(true);
    }, []);

    useEffect(() => {
        if (themeLoaded) {
            localStorage.setItem("theme", ThemeType[theme]);
        }
    }, [theme, themeLoaded]);

    return <Context.Provider value={{
        theme,
        setTheme: newValue => setTheme(newValue),
    }}>
        <ThemeProvider theme={themeResult}>
            {children}
        </ThemeProvider>
    </Context.Provider>;
}
